import { Switch } from '@mui/material'
import styled, { css } from 'styled-components'
import { Colors, inputState } from 'styles'
import { SwitchPropTypes } from './Switch.types'

export const SwitchStyles = styled(Switch)<SwitchPropTypes>`
  padding: 0;
  margin: 0;
  width: 4.8rem;
  height: 2.6rem;

  .MuiButtonBase-root {
    .MuiSwitch-thumb {
      width: 1.8rem;
      height: 1.8rem;
      box-shadow: 0 0.3rem 0.6rem ${Colors.black}29;
      color: ${Colors.white};
      transition: all 0.2s;
    }

    .Mui-checked {
      .MuiSwitch-thumb {
        color: ${Colors.white};
        transition: all 0.2s;
      }
    }
  }

  .MuiSwitch-track {
    border-radius: 1.6rem;
    opacity: 1 !important;
    border: 0.1rem solid ${({ theme }) => theme.palette.grey[100]};
    background-color: ${Colors.lightGrey};
    transition: all 0.2s;
  }

  .MuiSwitch-switchBase {
    padding: 0.3rem;
    border: 0.1rem solid transparent;
    transition: all 0.2s;
  }

  .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
    background-color: ${Colors.info};
    transition: all 0.2s;
  }

  .MuiTouchRipple-root {
    display: none;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      .MuiSwitch-track {
        border-color: transparent;
      }
      .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
        background-color: ${Colors.grey};
      }
    `};

  ${({ error }) =>
    error &&
    css`
      .MuiSwitch-track {
        border-color: ${Colors.danger};
        background-color: ${Colors.dangerLight}20;
      }
      .MuiButtonBase-root {
        .MuiSwitch-thumb {
          color: ${Colors.danger};
        }
      }
      .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
        background-color: ${Colors.dangerLight}70;
      }
    `};

  ${({ success }) =>
    success &&
    css`
      .MuiSwitch-track {
        border-color: ${Colors.success};
        background-color: ${Colors.successLight}20;
      }

      .MuiButtonBase-root {
        .MuiSwitch-thumb {
          color: ${Colors.success};
        }
      }
      .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
        background-color: ${Colors.successLight}70;
      }
    `};

  ${({ hovered }) =>
    hovered &&
    css`
      .MuiSwitch-track {
        background-color: ${Colors.lighterGrey};
      }
    `};

  ${({ focused }) =>
    focused &&
    css`
      .MuiSwitch-track {
        background-color: ${Colors.infoLight}40;
        ${inputState.focused(focused)}
      }
      .MuiButtonBase-root {
        .MuiSwitch-thumb {
          border: 0.1rem solid ${Colors.infoLight};
        }
      }
    `}
`
